// JsFromRoutes CacheKey 4ffc73128a0e23ce1d6242f896d2c63b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  destroy: definePathHelper('patch', '/integrations/:integration_id/authorization'),
}
